import { render, staticRenderFns } from "./CarouselIcon.vue?vue&type=template&id=60dada62&"
import script from "./CarouselIcon.vue?vue&type=script&lang=js&"
export * from "./CarouselIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports